// Pure validation + POST for the intake form. Store-agnostic.
import { FOUNDING_AGENT_REQUEST_TIMEOUT_MS } from "../session.js";
const PHONE_RE = /^[0-9+()\-.\s]{7,32}$/;
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export function validateIntakeValues(fields, values) {
    const responses = {};
    for (const f of fields) {
        const v = (values[f.key] ?? "").trim();
        if (!v) {
            if (f.required)
                return { ok: false, error: `${f.label} is required` };
            continue;
        }
        if (f.type === "email" && !EMAIL_RE.test(v))
            return { ok: false, error: "Enter a valid email" };
        if (f.type === "phone") {
            const digits = v.replace(/\D/g, "").length;
            if (!PHONE_RE.test(v) || digits < 7)
                return { ok: false, error: "Enter a valid phone number" };
        }
        responses[f.key] = v;
    }
    return { ok: true, responses };
}
export async function postIntake(serviceUrl, publishableKey, body) {
    const base = serviceUrl.replace(/\/+$/, "");
    let res;
    try {
        res = await fetch(`${base}/api/founding-agent/public/intake?key=${encodeURIComponent(publishableKey)}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
            signal: AbortSignal.timeout(FOUNDING_AGENT_REQUEST_TIMEOUT_MS),
        });
    }
    catch (err) {
        // AbortSignal.timeout() rejects with a DOMException named "TimeoutError",
        // which doesn't reliably subclass Error across runtimes -- check by name.
        if (err && typeof err === "object" && "name" in err && err.name === "TimeoutError") {
            throw new Error("Intake submit timed out");
        }
        throw err;
    }
    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Intake submit failed (${res.status})`);
    }
}
